export enum ShippingAdditionalFields {
    contactId = 'contactId',
}
